import {
  Autocomplete,
  createTheme,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";

import { useEffect, useRef } from "react";
import { animate } from "framer-motion";
import { backend_api } from "../static/server";
import axios from "axios";
import { countryOptions } from "../static/staticdata";
const styles = {
  custom_container: "w-11/12 hidden sm:block",
  heading:
    "text-[27px] text-center md:text-start font-[600] font-Roboto pb-[20px]",
  section: "w-11/12 mx-auto",
  productTitle: "text-[25px] font-[600] font-Roboto text-[#333]",
  productDiscountPrice: "font-bold text-[18px] text-[#333] font-Roboto",
  price: "font-[500] text-[16px] text-[#d55b45] pl-3 mt-[-4px] line-through",
  shop_name: "pt-3 text-[15px] text-blue-400 pb-3",
  active_indicator: "absolute bottom-[-27%] left-0 h-[3px] w-full bg-[crimson]",
  button:
    "w-[150px] bg-black h-[50px] my-3 flex items-center justify-center rounded-xl cursor-pointer",
  cart_button:
    "px-[20px] h-[38px] rounded-[20px] bg-[#f63b60] flex items-center justify-center cursor-pointer",
  cart_button_text: "text-[#fff] text-[16px] font-[600]",
  input: "w-full border p-1 rounded-[5px]",
  activeStatus:
    "w-[10px] h-[10px] rounded-full absolute top-0 right-1 bg-[#40d132]",
  noramlFlex: "flex items-center",
  border_button:
    "border-2 border-[#3957db] text-[#3957db] px-4 py-2 rounded-lg shadow",
  title: "text-[1.2rem] font-[500] font-Roboto text-[#333]",
};
// #3957db blue
export default styles;

// Base z-index for Material UI dialogs. All custom dialogs should start above this.
// export const dialogBaseZIndex = 2200;
// export const dropdownBaseZIndex = dialogBaseZIndex + 10;

export const lebaleStyle = {
  fontSize: "0.9rem",
  fontWeight: 500,
};

export const pageScrollStyle = {
  "&::-webkit-scrollbar": { width: "0.4rem" },
  "&::-webkit-scrollbar-track": {
    border: "1px solid #e5e5e5",
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "theme.palette.primary.main",
    borderRadius: "10px",
  },
};
export const headingStyle = {
  color: "transparent",
  fontWeight: 600,
  background: "linear-gradient(90deg, #472ed1 60%, #aa9bff )",
  backgroundClip: "text",
  WebkitBackgroundClip: "text",
  letterSpacing: "-0.5px",
  fontSize: { xs: "2rem", md: "2.5rem" },
  position: "relative",
  display: "inline-block",
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: "-5px",
    left: "10%",
    right: "10%",
    height: "4px",
    background: "linear-gradient(90deg, #472ed1, transparent)",
    borderRadius: "2px",
  },
};

export const compactGridStyle = {
  ...pageScrollStyle,
  "& .MuiDataGrid-root": {
    fontSize: "0.875rem", // Smaller font size
  },
  "& .MuiDataGrid-cell": {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    borderBottom: "1px solid #e5e5e5",
    textTransform: "capitalize",
    padding: "4px 8px", // Reduced cell padding
    minHeight: "36px !important", // Smaller row height
    maxHeight: "36px !important",
  },
  "& .MuiDataGrid-row": {
    minHeight: "36px !important", // Smaller row height
    maxHeight: "36px !important",
  },
  "& .MuiDataGrid-columnHeaders": {
    minHeight: "36px !important", // Smaller header height
    maxHeight: "36px !important",
    backgroundColor: "#00b3b02c",
    fontSize: "0.875rem",
  },
  "& .MuiDataGrid-columnHeader": {
    padding: "4px 8px", // Reduced header padding
    height: "36px !important",
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-main": {
    overflow: "auto",
    scrollbarWidth: "thin",
    scrollBehavior: "smooth",
  },
  "& .MuiDataGrid-virtualScroller": {
    overflow: "auto",
    scrollBehavior: "smooth",
  },
  "& .MuiDataGrid-footerContainer": {
    minHeight: "36px", // Smaller footer height
  },
};

// // FORMAT NUMBERS WITH COMMAS LIKE (27,444)
// export const formatNumberWithCommas = (number) => {
//   return number.toLocaleString();
// };

// // PRICE FUNCTION
// export const MrPrice = (Price) => {
//   return Price?.toLocaleString("en-US", {
//     style: "currency",
//     currency: "INR",
//   });
// };

// GREETING FUNCTION
export const getGreeting = () => {
  const hour = new Date().toLocaleString("en-US", {
    timeZone: "Asia/Kolkata",
    hour12: false,
    hour: "numeric",
  });

  if (hour >= 4 && hour < 12) {
    return "Good morning!";
  } else if (hour >= 12 && hour < 17) {
    return "Good afternoon!";
  } else {
    return "Good evening!";
  }
};

// // USER STATUS (2 MONTH'S AGO) FUNCTION
// export const timeAgo = (timestamp) => {
//   const secondsAgo = Math.floor((Date.now() - timestamp) / 1000);

//   const intervals = {
//     year: 31536000,
//     month: 2592000,
//     day: 86400,
//     hour: 3600,
//     minute: 60,
//   };

//   for (let interval in intervals) {
//     const value = Math.floor(secondsAgo / intervals[interval]);
//     if (value >= 1) {
//       return value + " " + (value === 1 ? interval : interval + "s") + " ago";
//     }
//   }

//   return "Just now";
// };

// // date formate log date
export const formattedDate = (date) => {
  return new Date(date).toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};
export const formatteDateDay = (date) => {
  return new Date(date).toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
};

// //phonenumber formatt
// export const formatPhoneNumber = (phoneNumber) => {
//   const numericOnly = phoneNumber.replace(/\D/g, "");
//   const formattedNumber = `+${numericOnly.slice(0, 2)} ${numericOnly.slice(
//     2,
//     7
//   )} ${numericOnly.slice(7)}`;

//   return formattedNumber;
// };

// // Get First character of each word
export const getFirstCharacters = (name) => {
  if (!name) return null; // Handling null or undefined cases
  return name
    .split(" ")
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase();
};

export const calculatePresent = (totalnum, num) => {
  return Math.round((num / totalnum) * 100);
};

export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

// Utility function for debounce
export const debounce = (func, delay) => {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

export const CountryCodeSelect = ({ value, onChange }) => {
  const selectedOption =
    countryOptions.find((option) => option.code === value) || countryOptions[0];

  return (
    <Autocomplete
      size="small"
      value={selectedOption}
      onChange={(event, newValue) => {
        if (newValue) {
          onChange(newValue.code);
        }
      }}
      options={countryOptions}
      getOptionLabel={(option) => option.code}
      renderOption={(props, option) => (
        <li {...props}>
          <span style={{ fontWeight: 600, marginRight: 8 }}>{option.code}</span>
          {/* <span style={{ color: "#666", fontSize: "0.9em" }}>
            {option.label}
          </span> */}
        </li>
      )}
      filterOptions={(options, { inputValue }) => {
        const searchTerm = inputValue.toLowerCase();
        return options.filter(
          (option) =>
            option.code.toLowerCase().includes(searchTerm) ||
            option.label.toLowerCase().includes(searchTerm),
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          sx={{
            "& .MuiOutlinedInput-root": {
              paddingRight: "39px !important",
            },
          }}
        />
      )}
      sx={{
        minWidth: "50px",
        "& .MuiOutlinedInput-root": {
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          "& .MuiOutlinedInput-notchedOutline": {
            borderRight: "none",
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
        },
        "& .MuiAutocomplete-input": {
          padding: "2.5px 4px !important",
        },
      }}
      disableClearable
      isOptionEqualToValue={(option, value) => option.code === value.code}
    />
  );
};

export const calculateContrastColor = (bgColor) => {
  if (!bgColor) return "#ffffff"; // Default to white if no color is provided

  // Convert named colors to RGB
  if (!/^#|rgb|hsl/.test(bgColor)) {
    const tempEl = document.createElement("div");
    tempEl.style.color = bgColor;
    document.body.appendChild(tempEl);
    const rgbColor = window.getComputedStyle(tempEl).color;
    document.body.removeChild(tempEl);
    bgColor = rgbColor;
  }

  let r, g, b;

  // Convert HEX to RGB
  if (bgColor.startsWith("#")) {
    if (bgColor.length === 4) {
      // Convert shorthand hex (#abc → #aabbcc)
      r = parseInt(bgColor[1] + bgColor[1], 16);
      g = parseInt(bgColor[2] + bgColor[2], 16);
      b = parseInt(bgColor[3] + bgColor[3], 16);
    } else {
      r = parseInt(bgColor.substring(1, 3), 16);
      g = parseInt(bgColor.substring(3, 5), 16);
      b = parseInt(bgColor.substring(5, 7), 16);
    }
  }
  // Convert RGB(A) to RGB
  else if (bgColor.startsWith("rgb")) {
    const rgbMatch = bgColor.match(/\d+/g);
    if (rgbMatch) {
      [r, g, b] = rgbMatch.map(Number);
    }
  }
  // Convert HSL to RGB
  else if (bgColor.startsWith("hsl")) {
    const hslMatch = bgColor.match(/\d+/g);
    if (hslMatch) {
      let [h, s, l] = hslMatch.map(Number);
      s /= 100;
      l /= 100;
      let c = (1 - Math.abs(2 * l - 1)) * s;
      let x = c * (1 - Math.abs(((h / 60) % 2) - 1));
      let m = l - c / 2;
      let r1, g1, b1;
      if (h < 60) [r1, g1, b1] = [c, x, 0];
      else if (h < 120) [r1, g1, b1] = [x, c, 0];
      else if (h < 180) [r1, g1, b1] = [0, c, x];
      else if (h < 240) [r1, g1, b1] = [0, x, c];
      else if (h < 300) [r1, g1, b1] = [x, 0, c];
      else [r1, g1, b1] = [c, 0, x];
      r = Math.round((r1 + m) * 255);
      g = Math.round((g1 + m) * 255);
      b = Math.round((b1 + m) * 255);
    }
  }

  // **Enhanced Contrast Calculation using WCAG Standards**
  const luminance = (color) => {
    let c = color / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  };

  const L =
    0.2126 * luminance(r) + 0.7152 * luminance(g) + 0.0722 * luminance(b);

  // Return black (#000) for bright backgrounds and white (#fff) for dark backgrounds
  return L > 0.5 ? "#000000" : "#ffffff";
};
export const generateUniqueMatterName = (id, name) => {
  const formattedId = id ? id.toString().padStart(4, "0") : "";
  const formattedName = name || "";

  return formattedId && formattedName
    ? // ? `${formattedId}-${formattedName}`
      `${formattedName}`
    : formattedId || formattedName || "Unknown Matter";
};

export const base64ToFile = (base64String, fileName) => {
  // Extract MIME type and base64 content
  const matches = base64String.match(/^data:(.+);base64,(.+)$/);
  if (!matches) {
    throw new Error("Invalid base64 format");
  }

  const contentType = matches[1];
  const byteCharacters = atob(matches[2]);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: contentType });

  return new File([blob], fileName, { type: contentType });
};

export const appendTeamMemberLawyerId = (url, lawyerId) => {
  if (!lawyerId) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}lawyer_id=${lawyerId}`;
};

export const useFollowMotion = ({
  classNames = [],
  speed = 0.2,
  deviationX = 40,
  deviationY = 30,
}) => {
  const mouse = useRef({ x: window.innerWidth / 2, y: window.innerHeight / 2 });
  const animationFrameId = useRef(null);
  const elementsRef = useRef([]);
  const controlsRef = useRef([]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      mouse.current = { x: e.clientX, y: e.clientY };
    };

    window.addEventListener("mousemove", handleMouseMove);

    // Wait for DOM elements to be available
    const initAnimation = () => {
      // Get elements by ID (not class names)
      elementsRef.current = classNames
        .map((id) => document.getElementById(id))
        .filter(Boolean); // Remove null elements

      if (elementsRef.current.length === 0) {
        // Retry after a short delay if elements not found
        setTimeout(initAnimation, 100);
        return;
      }

      // Initialize controls for each element
      controlsRef.current = elementsRef.current.map(() => ({ x: 0, y: 0 }));

      // Start animation loop
      const animateLoop = () => {
        elementsRef.current.forEach((el, index) => {
          const rect = el.getBoundingClientRect();
          const centerX = rect.left + rect.width / 2;
          const centerY = rect.top + rect.height / 2;

          const relX = mouse.current.x - centerX;
          const relY = mouse.current.y - centerY;

          const waveX = Math.sin(Date.now() * 0.002 + index) * deviationX;
          const waveY = Math.cos(Date.now() * 0.002 + index) * deviationY;

          const targetX = relX * speed + waveX;
          const targetY = relY * speed + waveY;

          animate(
            controlsRef.current[index],
            { x: targetX, y: targetY },
            {
              type: "spring",
              stiffness: 50,
              damping: 20,
              mass: 1,
              onUpdate: (latest) => {
                el.style.transform = `translate(${latest.x}px, ${latest.y}px)`;
              },
            },
          );
        });

        animationFrameId.current = requestAnimationFrame(animateLoop);
      };

      animateLoop();
    };

    // Start initialization after component mounts
    setTimeout(initAnimation, 100);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      if (animationFrameId.current) {
        cancelAnimationFrame(animationFrameId.current);
      }
    };
  }, [classNames, speed, deviationX, deviationY]);
};

export const getUserIpWithCountry = async () => {
  try {
    const res = await axios.get(`${backend_api}user-country`);
    const { country, country_code } = res.data.detail;

    return { country, country_code };
  } catch (error) {
    console.error("Error fetching user country:", error);
    return null;
  }
};
